import React, { useEffect, useState } from "react";
import styles from "./PDOModel.module.css";
import CancerName from "./CancerName";
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

// PBMC / TIL / CAF 한 갈래. PDOModel 과 같은 모양이고 데이터만 /api/getCellData 에서 받는다.
function CellModel({ name, search }) {
    const [visible, setVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const currentItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(items.length / itemsPerPage); i++) pageNumbers.push(i);
    const checkZero = (n) => (n === 0 || !n ? '' : `(${n})`);

    useEffect(() => {
        fetch('/api/getCellData', {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ name, search }),
        })
            .then((response) => response.json())
            .then((data) => {
                setItems(Array.isArray(data) ? data : []);
                setCurrentPage(1);
            })
            .catch((err) => console.error("Cell data fetch error:", err));
    }, [search, name]);

    return (
        <div className={styles.pdoObject}>
            <div onClick={() => setVisible(!visible)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img
                        className={visible ? styles.minusImg_low : styles.plusImg_low}
                        src={visible ? downTriangleIcon : sideTriangleIcon}
                        alt={visible ? "Collapse" : "Expand"}
                    />
                </span>
                <span className={styles.pdoName}>
                    {name}
                    <span className={styles.cancerDataNum}>{checkZero(items.length)}</span>
                </span>
            </div>
            {visible && (
                <div className={styles.contentContainer}>
                    <div className={styles.cancerNamesContainer}>
                        {currentItems.map((data) => (
                            <CancerName data={data} key={`cell-${data.Organoid_Info_Key}`} />
                        ))}
                    </div>
                    <div className={styles.paginationContainer}>
                        {pageNumbers.map((number) => (
                            <span
                                key={number}
                                className={currentPage === number ? styles.activePage : styles.pageNumber}
                                onClick={() => setCurrentPage(number)}
                            >
                                {number}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default CellModel;
